import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';

const gatewayProd = 'https://studio-service.stilingue.com.br';
const gatewayStaging = 'https://studio-service.warroom-test.com.br';

const afterParser = (response) => {
  return response.data;
};

export default class StudioService extends Service {
  constructor(isStaging) {
    const gateway = isStaging ? gatewayStaging : gatewayProd;
    const api = createApi('', gateway, {
      authNotFound: () => true,
    });
    super(api, { afterParser });
  }

  getConnectedPages(params = {}) {
    return this.find({
      params: {
        ...params,
      },
      url: '/pages',
      crossDomain: true,
    });
  }

  getUniverseInfo(params = {}) {
    return this.find({
      params: {
        ...params,
      },
      url: '/universe',
      crossDomain: true,
    });
  }

  getRepliers(params = {}) {
    return this.find({
      params: {
        ...params,
      },
      url: '/repliers',
      crossDomain: true,
    });
  }
}
